// src/pages/TpLink/TapoApp/index.jsx
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function TapoApp() {
  return (
    <div className="min-h-screen bg-[#111111] text-white scroll-smooth">
      <Helmet>
        <title>Tapo Smart App | TP-Link | SeguraTech</title>
        <meta
          name="description"
          content="Learn about the TP-Link Tapo Smart App — your all-in-one control centre for cameras, lighting, plugs, and hubs."
        />
        <meta property="og:title" content="Tapo Smart App | TP-Link | SeguraTech" />
        <meta
          property="og:description"
          content="Control all your TP-Link Tapo smart devices from one simple app. Create automation, manage energy, and monitor security — anytime, anywhere."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.seguratech.co.uk/tplink/app" />
        <meta property="og:image" content="/tplink-logo.png" />
      </Helmet>

      {/* Hero Section */}
      <section className="max-w-4xl mx-auto px-4 py-24 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold text-[#C6A564] mb-6">
          Tapo Smart App
        </h1>
        <p className="text-lg text-white/80 mb-10">
          Control your lighting, cameras, and power devices from one seamless interface.
          The Tapo App gives you full command of your home — whether you’re on the sofa or halfway across the world.
        </p>
      </section>

      {/* Features */}
      <section className="max-w-6xl mx-auto px-4 pb-24 grid md:grid-cols-2 gap-10 text-center">
        <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition">
          <h3 className="text-2xl font-semibold text-[#C6A564] mb-3">Instant Control</h3>
          <p className="text-white/80">
            Power devices on or off, adjust brightness, or check your cameras in real time with one tap.
          </p>
        </div>

        <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition">
          <h3 className="text-2xl font-semibold text-[#C6A564] mb-3">Automation Made Easy</h3>
          <p className="text-white/80">
            Create smart routines, timers, and energy-saving schedules across all your Tapo devices.
          </p>
        </div>
      </section>

      {/* Back Link */}
      <div className="text-center pb-16">
        <Link
          to="/tplink"
          className="text-[#C6A564] hover:text-[#E7D7B0] transition underline"
        >
          ← Back to TP-Link Overview
        </Link>
      </div>
    </div>
  );
}
